<template>
  <li class="venue-note">
     <button type="button" class="close" aria-label="Close" @click="$emit('deleteNote', note)">
      <span aria-hidden="true">&times;</span>
    </button>
    {{note}}
  </li>
</template>

<script>
export default {
  name: 'note',
  props: {
    note: {
      required: true,
      type: String
    }
  },
  data: function() {
    return {
      editing: false
    }
  }

}
</script>

<style lang="scss" scoped>
  .venue-note {
    list-style-type: none;
    .close {
      display: none;
    }
    &:hover {
      .close {
        display: block;
      }
    }
  }

</style>
